import { ChartOptionsProvider, CHART_FLEXED_COLOUR, CHART_EXPECTATION_COLOUR, CHART_FORECAST_COLOUR } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class EbitVsSharePriceChartOptionsProvider extends ChartOptionsProvider {

  public getOptions(company) {
    let chartOptions;
    const forecasts = company.platformData.ebitMarginForecasts,
      trailingEbit = forecasts[forecasts.length - 1].value,
      sharePrice = company.platformData.sharePrice,
      sharePriceProportions = [0.7, 0.8, 0.9, 1.1, 1.2, 1.3],
      sharePriceRange = sharePriceProportions.map(proportion => proportion * sharePrice);

    chartOptions = {
      chart: { spacingBottom: 20 },
      title: `Implied EBIT Margin expectation vs. Share price (${company.platformData.currencyUnit})`,
      legend: {
        enabled: false
      },
      xAxis: {
        minTickInterval: null,
        allowDecimals: true
      },
      yAxis: {
        title: {
          text: null
        },

        allowDecimals: true,
        plotLines: [{
          color: CHART_FORECAST_COLOUR,
          dashStyle: 'solid',
          value: trailingEbit * 100,
          width: 2,
          label: {
            text: `Y3 EBIT Margin Forecast (${(trailingEbit * 100).toFixed(1)}%)`,
            align: 'right',
            x: -10,
            y: 16,
            style: {
              color: CHART_FORECAST_COLOUR
            }
          },
          zIndex: 15
        }]
      },

      tooltip: {
        headerFormat: '',
        pointFormat: `Price: {point.x:.2f} ${company.platformData.currencyUnit} - EBITM: {point.y:.2f}%`
      },

      series: [
        {
          name: 'Price vs EBIT Margin Expectation (%)',
          type: 'scatter',
          data: sharePriceRange.map(price =>
            [price, this.calculateEbitMarginExpectation(company, price) * 100]),
          visible: true,
          color: CHART_FLEXED_COLOUR,
          zIndex: 1001
        },
        {
          name: 'Current Price vs EBIT Margin Expectation (%)',
          type: 'scatter',
          data: [[sharePrice, company.platformData.ebitMarginExpectation * 100]],
          visible: true,
          color: CHART_EXPECTATION_COLOUR,
          zIndex: 1002
        }]
    }

    chartOptions = this.setYMax(chartOptions, (trailingEbit * 100));
    chartOptions = this.setYMin(chartOptions, (trailingEbit * 100) - ((trailingEbit * 100) / 10));
    return super.getOptions(company, chartOptions);
  };

  calculateEbitMarginExpectation(company, sharePrice) {
    const currentSharePrice = company.platformData.sharePrice,
      ebitMarginExpectation = company.platformData.ebitMarginExpectation,
      marketCap = company.platformData.componentsOfValue.marketCap,
      discountCashFlow = company.platformData.cashFlowAnalysis.discountCashFlow,
      terminalCashFlow = company.platformData.cashFlowAnalysis.terminalCashFlow,
      taxRate = company.platformData.componentsOfValue.taxRate,
      fai = company.platformData.faiHistoric[company.platformData.faiHistoric.length - 1].value,
      wci = company.platformData.wciHistoric[company.platformData.wciHistoric.length - 1].value;

    const year8toYear30DCF = discountCashFlow.slice(7).map(item => item.value).reduce((total, currentValue) => total + currentValue);
    const y8Toy30PlusTerminalValue = year8toYear30DCF + terminalCashFlow;

    const sharePriceFactor = ((sharePrice / currentSharePrice) - 1);
    const derivative = (ebitMarginExpectation * (1 - taxRate)) / ((ebitMarginExpectation * (1 - taxRate)) - (0.05 * (fai + wci)));
    return ebitMarginExpectation + ((marketCap * ebitMarginExpectation) / (y8Toy30PlusTerminalValue * derivative)) * ((sharePrice / currentSharePrice) - 1)
  }


}



// WEBPACK FOOTER //
// ./src/providers/chart-options/ebit-vs-share-price.ts